import { ListAlt } from '@mui/icons-material'
import { Button, Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material'
import { ToDoListFilterDialog } from 'components'
import * as controllers from 'controllers'
import { useAuth } from 'context'
import { ImportBranchDto, ToDoList, ToDoListName, ToDoListsCountsDto } from 'dtos'
import { useLoadingState } from 'hooks'
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ArchivedToDoListDetails from './ArchivedToDoListDetails'
import BrokerDocumentsToDoListDetails from './BrokerDocumentsToDoListDetails'
import CancelledToDoListDetails from './CancelledToDoListDetails'
import Created5DaysAgoOrMoreAndHasNotBeenSentToDOTToDoListDetails from './Created5DaysAgoOrMoreAndHasNotBeenSentToDOTToDoListDetails'
import Needs7501DocumentMichiganToDoListDetails from './Needs7501DocumentMichiganToDoListDetails'
import NeedsBWIApprovalTodoList from './NeedsBWIApprovalTodoList'
import NeedsCANOwnershipMichiganToDoListDetails from './NeedsCANOwnershipMichiganToDoListDetails'
import NeedsCaRoUploadedToDoListDetails from './NeedsCaRoUploadedToDoListDetails'
import NeedsCheckInToDoListDetails from './NeedsCheckInToDoListDetails'
import NeedsClusterConversionInHouseToDoListDetails from './NeedsClusterConversionInHouseToDoListDetails'
import NeedsClusterConversionShipperToDoListDetails from './NeedsClusterConversionShipperToDoListDetails'
import NeedsClusterDeliveredToThirdPartyConversionCompanyToDoListDetails from './NeedsClusterDeliveredToThirdPartyConversionCompanyToDoListDetails'
import NeedsClusterReinstalledToDoListDetails from './NeedsClusterReinstalledToDoListDetails'
import NeedsClusterRemovedToDoListDetails from './NeedsClusterRemovedToDoListDetails'
import NeedsDamageRepairedToDoListDetails from './NeedsDamageRepairedToDoListDetails'
import NeedsInHouseAdditionalProgrammingToDoListDetails from './NeedsInHouseAdditionalProgrammingToDoListDetails'
import NeedsIncorrectMileageResolutionToDoListDetails from './NeedsIncorrectMileageResolutionToDoListDetails'
import NeedsInfoForApplicationPacketMichiganToDoListDetails from './NeedsInfoForApplicationPacketMichiganToDoListDetails'
import NeedsManufacturerLabelExporterToDoListDetails from './NeedsManufacturerLabelExporterToDoListDetails'
import NeedsManufacturerLabelToDoListDetails from './NeedsManufacturerLabelToDoListDetails'
import NeedsMichiganTitleApplicationReceiptToDoListDetails from './NeedsMichiganTitleApplicationReceiptToDoList'
import NeedsOEMSiteCheckedForRecallsTodoListDetails from './NeedsOEMSiteCheckedForRecallsTodoListDetails'
import NeedsPhotoToDoListDetails from './NeedsPhotoToDoListDetails'
import NeedsRecallWorkToDoListDetails from './NeedsRecallWorkToDoListDetails'
import SignedForeignShipperToDoListDetails from './NeedsSignedForeignShipperToDoListDetails'
import NeedsTPMSTelltaleImageExporterPerAppendixBToDoList from './NeedsTPMSTelltaleImageExporterPerAppendixBToDoList'
import NeedsThirdPartyAdditionalProgrammingToDoListDetails from './NeedsThirdPartyAdditionalProgrammingToDoListDetails'
import NeedsTirePressureLabelToDoListDetails from './NeedsTirePressureLabelToDoListDetails'
import NeedsToBePrintedAndSignedToDoListDetails from './NeedsToBePrintedAndSignedToDoListDetails'
import SpecialBondToDoListDetails from './SpecialBondToDoListDetails'
import ToBeAddToPAPSToDoListDetails from './ToBeAddToPAPSToDoListDetails'
import WaitingOnExporterToDoListDetails from './WaitingOnExporterToDoListDetails'
import WaitingOnThirdPartyAdditionalProgrammingToDoListDetails from './WaitingOnThirdPartyAdditionalProgrammingToDoListDetails'
import WaitingOnThirdPartyClusterConversionToDoListDetails from './WaitingOnThirdPartyClusterConversionToDoListDetails'
import WaitingOnTripToDoListDetails from './WaitingOnTripToDoListDetails'
import NeedsMichiganTitleFromSecretaryOfStateToDoListDetails from './michiganTitles/NeedsMichiganTitleFromSecretaryOfStateToDoListDetails'
import MichiganTitlesNeedsToBeSentOutgoingToDoList from './michiganTitles/NeedsToBeSentOutgoingToDoList'
import NeedsToBeTakenToSecretaryOfStateToDoListDetails from './michiganTitles/NeedsToBeTakenToSecretaryOfStateToDoListDetails'

import Approaching120DaysSinceEntryDateToDoList from './conformity/Approaching120DaysSinceEntryDateToDoList'
import SendBackToCanadaToDoList from './conformity/SendBackToCanadaToDoList'
import VehiclesEligibleForConformityToDoList from './conformity/VehiclesEligibleForConformityToDoList'

import NeedsDriversLicensePhotoUploadedToDoList from './outboundTrips/NeedsDriversLicensePhotoUploadedToDoList'
import NeedsSignedBOLToDoList from './outboundTrips/NeedsSignedBOLToDoList'
import NeedsToBeMovedToStagingToDoList from './outboundTrips/NeedsToBeMovedToStagingToDoList'
import ReadyForOutboundTripToDoList from './outboundTrips/ReadyForOutboundTripToDoList'

import NeedsToBeAddedToABundleToDoList from './ohioBuildABoxes/NeedsToBeAddedToABundleToDoList'
import NeedsToHaveBoxFinishedToDoList from './ohioBuildABoxes/NeedsToHaveBoxFinishedToDoList'
import NeedsToBeTakenToFedExToDoList from './ohioBuildABoxes/NeedsToBeTakenToFedExToDoList'
import WaitingOnOhioTitleProcessingToDoList from './ohioBuildABoxes/WaitingOnOhioTitleProcessingToDoList'
import NeedsNewTitlesOCRdToDoList from './ohioBuildABoxes/NeedsNewTitlesOCRdToDoList'
import NeedsToBeSentOutgoingToDoList from './ohioTitles/NeedsToBeSentOutgoingToDoList'

export default function ToDoListIndex() {
  const location = useLocation()
  const navigate = useNavigate()
  const { status, user } = useAuth()
  const importBranchBootstrapDoneRef = useRef(false)

  const [importBranch, setImportBranch] = useState<ImportBranchDto | null>(null)
  const [importBranches, setImportBranches] = useState<ImportBranchDto[]>([])
  /** False until bootstrap applies import branch from URL, hydrated user default, or HQ fallback. Avoids counts running with null then again after branch is set (spinner flash). */
  const [importBranchSettled, setImportBranchSettled] = useState<boolean>(false)
  const [selectToDoListDialogOpen, setSelectToDoListDialogOpen] = useState<boolean>(false)
  const [toDoListCounts, setToDoListCounts] = useState<ToDoListsCountsDto>(new ToDoListsCountsDto())
  const [loadingState, setLoadingState] = useLoadingState({ isGettingToDoListCounts: false })
  const [todoListName, setTodoListName] = useState<ToDoListName>((sessionStorage.getItem('toDoList') as ToDoListName) ?? 'waiting-on-exporter')

  useEffect(() => {
    sessionStorage.setItem('toDoList', todoListName)
  }, [todoListName])

  useEffect(() => {
    if (importBranch?.importBranchGuid) {
      navigate(`${location.pathname}?toDoList=${encodeURIComponent(todoListName)}&importBranchGuid=${encodeURIComponent(importBranch?.importBranchGuid)}`, {
        replace: true
      })
    } else {
      navigate(`${location.pathname}?toDoList=${encodeURIComponent(todoListName)}`, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [todoListName, importBranch])

  useEffect(() => {
    if (!importBranchSettled) {
      return
    }
    setLoadingState('isGettingToDoListCounts', true)
    controllers.toDoLists
      .getToDoListsCounts(importBranch?.importBranchGuid)
      .then(response => {
        setToDoListCounts(response.value)
      })
      .finally(() => {
        setLoadingState('isGettingToDoListCounts', false)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [importBranch?.importBranchGuid, importBranchSettled])

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [todoLists, _setTodoLists] = useState<ToDoList[]>([
    {
      name: 'waiting-on-exporter',
      label: 'Waiting On Exporter',
      component: <WaitingOnExporterToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-special-bond',
      label: 'Needs Special Bond',
      component: <SpecialBondToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-manufacturer-label-image-exporter',
      label: 'Needs Manufacturer Label Image (Exporter)',
      component: <NeedsManufacturerLabelExporterToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-tmps-label-image-exporter',
      label: 'Needs TPMS Telltale Image (Exporter) Per Appendix B',
      component: <NeedsTPMSTelltaleImageExporterPerAppendixBToDoList />,
      count: 0
    },
    {
      name: 'needs-bwi-approval',
      label: 'Needs BWI Approval',
      component: <NeedsBWIApprovalTodoList />,
      count: 0
    },
    {
      name: 'needs-to-be-added-to-a-paps',
      label: 'Needs To Be Added To A PAPS',
      component: <ToBeAddToPAPSToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-broker-documents',
      label: 'Needs Broker Documents',
      component: <BrokerDocumentsToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-signed-foreign-shipper',
      label: 'Needs Signed Foreign Shipper',
      component: <SignedForeignShipperToDoListDetails />,
      count: 0
    },
    {
      name: 'waiting-on-trip',
      label: 'Waiting on Trip',
      component: <WaitingOnTripToDoListDetails />,
      count: 0
    },
    {
      name: 'cancelled',
      label: 'Cancelled',
      component: <CancelledToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-check-in',
      label: 'Needs Check In',
      component: <NeedsCheckInToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-manufacturer-label',
      label: 'Needs Manufacturer Label',
      component: <NeedsManufacturerLabelToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-tire-pressure-label',
      label: 'Needs Tire Pressure label',
      component: <NeedsTirePressureLabelToDoListDetails />,
      count: 0
    },

    {
      name: 'needs-photos',
      label: 'Needs Photos',
      component: <NeedsPhotoToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-oem-site-checked-for-recall',
      label: 'Needs OEM Site Checked For Recalls',
      component: <NeedsOEMSiteCheckedForRecallsTodoListDetails />,
      count: 0
    },
    {
      name: 'needs-ca-ro-uploaded',
      label: 'Needs CA RO Uploaded',
      component: <NeedsCaRoUploadedToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-recall-work',
      label: 'Needs Recall Work',
      component: <NeedsRecallWorkToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-cluster-removed',
      label: 'Needs Cluster Removed',
      component: <NeedsClusterRemovedToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-cluster-conversion-shipper',
      label: 'Needs Cluster Conversion Shipper',
      component: <NeedsClusterConversionShipperToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-cluster-delivered-to-third-party-conversion-company',
      label: 'Needs Cluster Delivered To Third Party Conversion Company',
      component: <NeedsClusterDeliveredToThirdPartyConversionCompanyToDoListDetails />,
      count: 0
    },
    {
      name: 'waiting-on-third-party-cluster-conversion',
      label: 'Waiting On Third Party Cluster Conversion',
      component: <WaitingOnThirdPartyClusterConversionToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-cluster-conversion-in-house',
      label: 'Needs Cluster Conversion In House',
      component: <NeedsClusterConversionInHouseToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-in-house-additional-programming',
      label: 'Needs In House Additional Programming',
      component: <NeedsInHouseAdditionalProgrammingToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-3rd-party-additional-programming',
      label: 'Needs 3rd Party Additional Programming',
      component: <NeedsThirdPartyAdditionalProgrammingToDoListDetails />,
      count: 0
    },
    {
      name: 'waiting-on-3rd-party-additional-programming',
      label: 'Waiting On 3rd Party Additional Programming',
      component: <WaitingOnThirdPartyAdditionalProgrammingToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-cluster-reinstalled',
      label: 'Needs Cluster Reinstalled',
      component: <NeedsClusterReinstalledToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-incorrect-mileage-resolution',
      label: 'Needs Incorrect Mileage Resolution',
      component: <NeedsIncorrectMileageResolutionToDoListDetails />,
      count: 0
    },
    // {
    //   name: 'needs-can-ownership-ohio',
    //   label: 'Needs CAN Ownership',
    //   component: <NeedsCANOwnershipToDoListDetails />,
    //   count: 0
    // },
    // {
    //   name: 'needs-7501-document-ohio',
    //   label: 'Needs 7501 Document',
    //   component: <Needs7501DocumentOhioToDoListDetails />,
    //   count: 0
    // },
    // {
    //   name: 'needs-info-for-application-packet-ohio',
    //   label: 'Needs Info For Application Packet',
    //   component: <NeedsInfoForApplicationPacketOhioToDoListDetails />,
    //   count: 0
    // },
    // {
    //   name: 'needs-to-be-marked-ready-for-build-a-box',
    //   label: 'Needs To Be Marked Ready For Build A Box',
    //   component: <NeedsToBeMarkedReadyForBuildABoxToDoListDetails />,
    //   count: 0
    // },
    {
      name: 'needs-to-be-added-to-a-bundle',
      label: 'Needs To Be Added To A Bundle',
      component: <NeedsToBeAddedToABundleToDoList />,
      count: 0
    },
    {
      name: 'needs-to-have-box-finished',
      label: 'Needs To Have Box Finished',
      component: <NeedsToHaveBoxFinishedToDoList />,
      count: 0
    },
    {
      name: 'needs-to-be-taken-to-fed-ex',
      label: 'Needs To Be Taken To FedEx',
      component: <NeedsToBeTakenToFedExToDoList />,
      count: 0
    },
    {
      name: 'waiting-on-ohio-title-processing',
      label: 'Waiting On Ohio Title Processing',
      component: <WaitingOnOhioTitleProcessingToDoList />,
      count: 0
    },
    {
      name: 'needs-new-titles-ocrd',
      label: `Needs New Titles OCR'd`,
      component: <NeedsNewTitlesOCRdToDoList />,
      count: 0
    },
    {
      name: 'needs-7501-document-michigan',
      label: 'Needs 7501 Document',
      component: <Needs7501DocumentMichiganToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-can-ownership-michigan',
      label: 'Needs CAN Ownership',
      component: <NeedsCANOwnershipMichiganToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-info-for-application-packet-michigan',
      label: 'Needs Info For Application Packet',
      component: <NeedsInfoForApplicationPacketMichiganToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-to-be-printed-and-signed',
      label: 'Needs To Be Printed And Signed',
      component: <NeedsToBePrintedAndSignedToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-to-be-taken-to-secretary-of-state',
      label: 'Needs To Be Taken To Secretary Of State',
      component: <NeedsToBeTakenToSecretaryOfStateToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-michigan-title-application-receipt',
      label: 'Needs Michigan Title Application Receipt',
      component: <NeedsMichiganTitleApplicationReceiptToDoListDetails />,
      count: 0
    },
    {
      name: 'needs-michigan-title-from-secretary-of-state',
      label: 'Needs Michigan Title From Secretary Of State',
      component: <NeedsMichiganTitleFromSecretaryOfStateToDoListDetails />,
      count: 0
    },
    {
      name: 'michigan-titles-needs-to-be-sent-outgoing',
      label: 'Michigan Titles - Needs To Be Sent Outgoing',
      component: <MichiganTitlesNeedsToBeSentOutgoingToDoList />,
      count: 0
    },
    // {
    //   name: 'ohio-titles-needs-to-be-sent-outgoing',
    //   label: 'Ohio Titles - Needs To Be Sent Outgoing',
    //   component: < />,
    //   count: 0
    // },
    {
      name: 'vehicles-eligible-for-conformity',
      label: 'Vehicles Eligible For Conformity',
      component: <VehiclesEligibleForConformityToDoList />,
      count: 0
    },
    {
      name: 'approaching-120-days-since-entry-date',
      label: 'Approaching 120 Days Since Entry Date',
      component: <Approaching120DaysSinceEntryDateToDoList />,
      count: 0
    },
    {
      name: 'send-back-to-canada',
      label: 'Send Back To Canada',
      component: <SendBackToCanadaToDoList />,
      count: 0
    },
    {
      name: 'ready-for-outbound-trip',
      label: 'ready-for-outbound-trip',
      component: <ReadyForOutboundTripToDoList />,
      count: 0
    },
    {
      name: 'needs-to-be-moved-to-staging',
      label: 'Needs To Be Moved To Staging',
      component: <NeedsToBeMovedToStagingToDoList />,
      count: 0
    },
    {
      name: 'needs-drivers-license-photo-uploaded',
      label: 'Needs Drivers License Photo Uploaded',
      component: <NeedsDriversLicensePhotoUploadedToDoList />,
      count: 0
    },
    {
      name: 'needs-signed-bol',
      label: 'Needs Signed BOL',
      component: <NeedsSignedBOLToDoList />,
      count: 0
    },
    {
      name: 'needs-damage-repaired',
      label: 'Needs Damage Repaired',
      component: <NeedsDamageRepairedToDoListDetails />,
      count: 0
    },
    {
      name: 'created-5-days-ago-or-more-and-has-not-been-sent-to-dot',
      label: 'Created 5 Days Ago Or More And Has Not Been Sent To DOT',
      component: <Created5DaysAgoOrMoreAndHasNotBeenSentToDOTToDoListDetails />,
      count: 0
    },
    {
      name: 'archived',
      label: 'Archived',
      component: <ArchivedToDoListDetails />,
      count: 0
    }
  ])

  useEffect(() => {
    let cancelled = false

    void (async () => {
      const branchesResponse = await controllers.getImportBranches()
      if (cancelled) {
        return
      }
      const branches = branchesResponse.value
      setImportBranches(branches)

      const importBranchGuidFromUrl = new URLSearchParams(location.search).get('importBranchGuid')

      if (importBranchGuidFromUrl) {
        setImportBranch(branches.find(b => b.importBranchGuid === importBranchGuidFromUrl) ?? null)
        importBranchBootstrapDoneRef.current = true
        if (!cancelled) {
          setImportBranchSettled(true)
        }
        return
      }

      if (importBranchBootstrapDoneRef.current) {
        return
      }

      if (status === 'loading') {
        return
      }

      if (status !== 'authorized' || !user?.personGuid) {
        setImportBranch(branches.find(b => b.specialIdentifier === 'HQ_LOCATION') ?? null)
        importBranchBootstrapDoneRef.current = true
        if (!cancelled) {
          setImportBranchSettled(true)
        }
        return
      }

      const defaultBranch = user.defaultImportBranch
      if (defaultBranch?.importBranchGuid) {
        setImportBranch(branches.find(b => b.importBranchGuid === defaultBranch.importBranchGuid) ?? null)
      } else {
        setImportBranch(null)
      }

      if (!cancelled) {
        importBranchBootstrapDoneRef.current = true
        setImportBranchSettled(true)
      }
    })()

    return () => {
      cancelled = true
    }
  }, [location.search, status, user])

  useEffect(() => {
    _setTodoLists([
      {
        name: 'waiting-on-exporter',
        label: 'Waiting On Exporter',
        component: <WaitingOnExporterToDoListDetails />,
        count: toDoListCounts.waitingOnExporter ?? 0
      },
      {
        name: 'needs-special-bond',
        label: 'Needs Special Bond',
        component: <SpecialBondToDoListDetails />,
        count: toDoListCounts.needsSpecialBond ?? 0
      },
      {
        name: 'needs-manufacturer-label-image-exporter',
        label: 'Needs Manufacturer Label Image (Exporter)',
        component: <NeedsManufacturerLabelExporterToDoListDetails />,
        count: toDoListCounts.needsManufacturerLabelImageExporter ?? 0
      },
      {
        name: 'needs-tmps-label-image-exporter',
        label: 'Needs TPMS Telltale Image (Exporter) Per Appendix B',
        component: <NeedsTPMSTelltaleImageExporterPerAppendixBToDoList />,
        count: toDoListCounts.needsTPMSLabelImageExporterPerAppendixB ?? 0
      },
      {
        name: 'needs-bwi-approval',
        label: 'Needs BWI Approval',
        component: <NeedsBWIApprovalTodoList />,
        count: toDoListCounts.needsBWIApproval ?? 0
      },
      {
        name: 'needs-to-be-added-to-a-paps',
        label: 'Needs To Be Added To A PAPS',
        component: <ToBeAddToPAPSToDoListDetails />,
        count: toDoListCounts.needsToBeAddedToAPAPS ?? 0
      },
      {
        name: 'needs-broker-documents',
        label: 'Needs Broker Documents',
        component: <BrokerDocumentsToDoListDetails />,
        count: toDoListCounts.needsBrokerDocuments ?? 0
      },
      {
        name: 'needs-signed-foreign-shipper',
        label: 'Needs Signed Foreign Shipper',
        component: <SignedForeignShipperToDoListDetails />,
        count: toDoListCounts.needsSignedForeignShipper ?? 0
      },
      {
        name: 'waiting-on-trip',
        label: 'Waiting on Trip',
        component: <WaitingOnTripToDoListDetails />,
        count: toDoListCounts.waitingOnTrip ?? 0
      },
      {
        name: 'cancelled',
        label: 'Cancelled',
        component: <CancelledToDoListDetails />,
        count: toDoListCounts.cancelled ?? 0
      },
      {
        name: 'needs-check-in',
        label: 'Needs Check In',
        component: <NeedsCheckInToDoListDetails />,
        count: toDoListCounts.needsCheckIn ?? 0
      },
      {
        name: 'needs-manufacturer-label',
        label: 'Needs Manufacturer Label',
        component: <NeedsManufacturerLabelToDoListDetails />,
        count: toDoListCounts.needsManufacturerLabel ?? 0
      },
      {
        name: 'needs-tire-pressure-label',
        label: 'Needs Tire Pressure label',
        component: <NeedsTirePressureLabelToDoListDetails />,
        count: toDoListCounts.needsTirePressureLabel ?? 0
      },
      {
        name: 'needs-photos',
        label: 'Needs Photos',
        component: <NeedsPhotoToDoListDetails />,
        count: toDoListCounts.needsPhotos ?? 0
      },
      {
        name: 'needs-oem-site-checked-for-recall',
        label: 'Needs OEM Site Checked For Recalls',
        component: <NeedsOEMSiteCheckedForRecallsTodoListDetails />,
        count: toDoListCounts.needsOEMSiteCheckedForRecalls ?? 0
      },
      {
        name: 'needs-ca-ro-uploaded',
        label: 'Needs CA RO Uploaded',
        component: <NeedsCaRoUploadedToDoListDetails />,
        count: toDoListCounts.needsCAROUploaded ?? 0
      },
      {
        name: 'needs-recall-work',
        label: 'Needs Recall Work',
        component: <NeedsRecallWorkToDoListDetails />,
        count: toDoListCounts.needsRecallWork ?? 0
      },
      {
        name: 'needs-cluster-removed',
        label: 'Needs Cluster Removed',
        component: <NeedsClusterRemovedToDoListDetails />,
        count: toDoListCounts.needsClusterRemoved ?? 0
      },
      {
        name: 'needs-cluster-conversion-shipper',
        label: 'Needs Cluster Conversion Shipper',
        component: <NeedsClusterConversionShipperToDoListDetails />,
        count: toDoListCounts.needsClusterConversionShipper ?? 0
      },
      {
        name: 'needs-cluster-delivered-to-third-party-conversion-company',
        label: 'Needs Cluster Delivered To Third Party Conversion Company',
        component: <NeedsClusterDeliveredToThirdPartyConversionCompanyToDoListDetails />,
        count: toDoListCounts.needsClusterDeliveredToThirdPartyConversionCompany ?? 0
      },
      {
        name: 'waiting-on-third-party-cluster-conversion',
        label: 'Waiting On Third Party Cluster Conversion',
        component: <WaitingOnThirdPartyClusterConversionToDoListDetails />,
        count: toDoListCounts.waitingOnThirdPartyClusterConversion ?? 0
      },
      {
        name: 'needs-cluster-conversion-in-house',
        label: 'Needs Cluster Conversion In House',
        component: <NeedsClusterConversionInHouseToDoListDetails />,
        count: toDoListCounts.needsClusterConversionInHouse ?? 0
      },
      {
        name: 'needs-in-house-additional-programming',
        label: 'Needs In House Additional Programming',
        component: <NeedsInHouseAdditionalProgrammingToDoListDetails />,
        count: toDoListCounts.needsInHouseAdditionalProgramming ?? 0
      },
      {
        name: 'needs-3rd-party-additional-programming',
        label: 'Needs 3rd Party Additional Programming',
        component: <NeedsThirdPartyAdditionalProgrammingToDoListDetails />,
        count: toDoListCounts.needsThirdPartyAdditionalProgramming ?? 0
      },
      {
        name: 'waiting-on-3rd-party-additional-programming',
        label: 'Waiting On 3rd Party Additional Programming',
        component: <WaitingOnThirdPartyAdditionalProgrammingToDoListDetails />,
        count: toDoListCounts.waitingOnThirdPartyAdditionalProgramming ?? 0
      },
      {
        name: 'needs-cluster-reinstalled',
        label: 'Needs Cluster Reinstalled',
        component: <NeedsClusterReinstalledToDoListDetails />,
        count: toDoListCounts.needsClusterReinstalled ?? 0
      },
      {
        name: 'needs-incorrect-mileage-resolution',
        label: 'Needs Incorrect Mileage Resolution',
        component: <NeedsIncorrectMileageResolutionToDoListDetails />,
        count: toDoListCounts.needsIncorrectMileageResolution ?? 0
      },

      // {
      //   name: 'needs-can-ownership-ohio',
      //   label: 'Needs CAN Ownership',
      //   component: <NeedsCANOwnershipToDoListDetails />,
      //   count: toDoListCounts.needsCANOwnershipOhio ?? 0
      // },
      // {
      //   name: 'needs-7501-document-ohio',
      //   label: 'Needs 7501 Document',
      //   component: <Needs7501DocumentToDoListDetails />,
      //   count: toDoListCounts.needs7501DocumentOhio ?? 0
      // },
      // {
      //   name: 'needs-info-for-application-packet-ohio',
      //   label: 'Needs Info For Application Packet',
      //   component: <NeedsInfoForApplicationPacketToDoListDetails />,
      //   count: toDoListCounts.needsInfoForApplicationPacketOhio ?? 0
      // },
      // {
      //   name: 'needs-to-be-marked-ready-for-build-a-box',
      //   label: 'Needs To Be Marked Ready for Build A Box',
      //   component: <NeedsToBeMarkedReadyForBuildABoxToDoListDetails />,
      //   count: toDoListCounts.needsToBeMarkedReadyForBuildABox ?? 0
      // },
      {
        name: 'needs-to-be-added-to-a-bundle',
        label: 'Needs To Be Added To A Bundle',
        component: <NeedsToBeAddedToABundleToDoList />,
        count: toDoListCounts.needsToBeAddedToABundle ?? 0
      },
      {
        name: 'needs-to-have-box-finished',
        label: 'Needs To Have Box Finished',
        component: <NeedsToHaveBoxFinishedToDoList />,
        count: toDoListCounts.needsToHaveBoxFinished ?? 0
      },
      {
        name: 'needs-to-be-taken-to-fed-ex',
        label: 'Needs To Be Taken To FedEx',
        component: <NeedsToBeTakenToFedExToDoList />,
        count: toDoListCounts.needsToBeTakenToFedEx ?? 0
      },
      {
        name: 'waiting-on-ohio-title-processing',
        label: 'Waiting On Ohio Title Processing',
        component: <WaitingOnOhioTitleProcessingToDoList />,
        count: toDoListCounts.waitingOnOhioTitleProcessing ?? 0
      },
      {
        name: 'needs-new-titles-ocrd',
        label: `Needs New Titles OCR'd`,
        component: <NeedsNewTitlesOCRdToDoList />,
        count: toDoListCounts.needsNewTitlesOCRd ?? 0
      },
      {
        name: 'needs-7501-document-michigan',
        label: 'Needs 7501 Document',
        component: <Needs7501DocumentMichiganToDoListDetails />,
        count: toDoListCounts.needs7501DocumentMichigan ?? 0
      },
      {
        name: 'needs-can-ownership-michigan',
        label: 'Needs CAN Ownership',
        component: <NeedsCANOwnershipMichiganToDoListDetails />,
        count: toDoListCounts.needsCANOwnershipMichigan ?? 0
      },
      {
        name: 'needs-info-for-application-packet-michigan',
        label: 'Needs Info For Application Packet',
        component: <NeedsInfoForApplicationPacketMichiganToDoListDetails />,
        count: toDoListCounts.needsInfoForApplicationPacketMichigan ?? 0
      },
      {
        name: 'needs-to-be-printed-and-signed',
        label: 'Needs To Be Printed And Signed',
        component: <NeedsToBePrintedAndSignedToDoListDetails />,
        count: toDoListCounts.needsToBePrintedAndSigned ?? 0
      },
      {
        name: 'needs-to-be-taken-to-secretary-of-state',
        label: 'Needs To Be Taken To Secretary of State',
        component: <NeedsToBeTakenToSecretaryOfStateToDoListDetails />,
        count: toDoListCounts.needsToBeTakenToSecretaryOfState ?? 0
      },
      {
        name: 'needs-michigan-title-application-receipt',
        label: 'Needs Michigan Title Application Receipt',
        component: <NeedsMichiganTitleApplicationReceiptToDoListDetails />,
        count: toDoListCounts.needsMichiganTitleApplicationReceipt ?? 0
      },
      {
        name: 'needs-michigan-title-from-secretary-of-state',
        label: 'Needs Michigan Title From Secretary of State',
        component: <NeedsMichiganTitleFromSecretaryOfStateToDoListDetails />,
        count: toDoListCounts.needsMichiganTitleFromSecretaryOfState ?? 0
      },
      {
        name: 'michigan-titles-needs-to-be-sent-outgoing',
        label: 'Michigan Titles Needs To Be Sent Outgoing',
        component: <MichiganTitlesNeedsToBeSentOutgoingToDoList />,
        count: toDoListCounts.michiganTitlesNeedsToBeSentOutgoing ?? 0
      },
      {
        name: 'ohio-titles-needs-to-be-sent-outgoing',
        label: 'Ohio Titles Needs To Be Sent Outgoing',
        component: <NeedsToBeSentOutgoingToDoList />,
        count: toDoListCounts.ohioTitlesNeedsToBeSentOutgoing ?? 0
      },
      {
        name: 'vehicles-eligible-for-conformity',
        label: 'Vehicles Eligible For Conformity',
        component: <VehiclesEligibleForConformityToDoList />,
        count: toDoListCounts.vehiclesEligibleForConformity ?? 0
      },
      {
        name: 'approaching-120-days-since-entry-date',
        label: 'Approaching 120 Days Since Entry Date',
        component: <Approaching120DaysSinceEntryDateToDoList />,
        count: toDoListCounts.approaching120DaysSinceEntryDate ?? 0
      },
      {
        name: 'send-back-to-canada',
        label: 'Send Back To Canada',
        component: <SendBackToCanadaToDoList />,
        count: toDoListCounts.sendBackToCanada ?? 0
      },
      {
        name: 'ready-for-outbound-trip',
        label: 'Ready For Outbound Trip',
        component: <ReadyForOutboundTripToDoList />,
        count: toDoListCounts.readyForOutboundTrip ?? 0
      },
      {
        name: 'needs-to-be-moved-to-staging',
        label: 'Needs To Be Moved To Staging',
        component: <NeedsToBeMovedToStagingToDoList />,
        count: toDoListCounts.needsToBeMovedToStaging ?? 0
      },
      {
        name: 'needs-drivers-license-photo-uploaded',
        label: 'Needs Drivers License Photo Uploaded',
        component: <NeedsDriversLicensePhotoUploadedToDoList />,
        count: toDoListCounts.needsDriversLicensePhotoUploaded ?? 0
      },
      {
        name: 'needs-signed-bol',
        label: 'Needs Signed BOL',
        component: <NeedsSignedBOLToDoList />,
        count: toDoListCounts.needsSignedBOL ?? 0
      },
      {
        name: 'needs-damage-repaired',
        label: 'Needs Damage Repaired',
        component: <NeedsDamageRepairedToDoListDetails />,
        count: toDoListCounts.needsDamageRepaired ?? 0
      },
      {
        name: 'created-5-days-ago-or-more-and-has-not-been-sent-to-dot',
        label: 'Created 5 Days Ago or More and Has Not Been Sent to DOT',
        component: <Created5DaysAgoOrMoreAndHasNotBeenSentToDOTToDoListDetails />,
        count: toDoListCounts.created5DaysAgoOrMoreAndHasNotBeenSentToDOT ?? 0
      },
      {
        name: 'archived',
        label: 'Archived',
        component: <ArchivedToDoListDetails />,
        count: toDoListCounts.archived ?? 0
      }
    ])
  }, [toDoListCounts])

  const onChangeImportBranch = (importBranch: ImportBranchDto | null) => {
    setImportBranch(importBranch)
  }

  const getToDoListLabel = (todoListName: ToDoListName): string => {
    const todoList = todoLists.filter(todoList => todoList.name === todoListName)[0]

    if (todoList) {
      return todoList.label
    }

    return 'To Do List'
  }

  const getToDoListCount = (toDoListName: ToDoListName): string => {
    const todoList = todoLists.filter(todoList => todoList.name === todoListName)[0]

    if (todoList) {
      return todoList.count.toString()
    }

    return '0'
  }

  const renderToDoList = (todoListName: ToDoListName): React.ReactNode => {
    const todoList = todoLists.filter(todoList => todoList.name === todoListName)[0]

    if (todoList) {
      return todoList.component
    }

    return <></>
  }

  return (
    <>
      <ToDoListFilterDialog
        importBranch={importBranch}
        importBranches={importBranches}
        isGettingToDoListCounts={loadingState.isGettingToDoListCounts}
        onChangeImportBranch={onChangeImportBranch}
        onChangeTodoList={todoListName => {
          setTodoListName(todoListName)
        }}
        onClose={() => {
          setSelectToDoListDialogOpen(false)
        }}
        open={selectToDoListDialogOpen}
        toDoListCounts={toDoListCounts}
        toDoListName={todoListName}
      />

      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Grid container justifyContent='space-between'>
                <Grid item>
                  <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
                    To Do List - {importBranch ? importBranch.name : 'All Locations'} - {getToDoListLabel(todoListName)}{' '}
                    {loadingState.isGettingToDoListCounts ? (
                      <CircularProgress color='inherit' size={16} sx={{ ml: 1 }} />
                    ) : (
                      `(${getToDoListCount(todoListName)})`
                    )}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm='auto' container spacing={2} alignItems='center' justifyContent='flex-end'>
                  <Grid item>
                    <Button
                      color='primary'
                      endIcon={<ListAlt />}
                      onClick={() => {
                        setSelectToDoListDialogOpen(true)
                      }}
                      variant='text'
                    >
                      SELECT TO DO LIST
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          {renderToDoList(todoListName)}
        </Grid>
      </Grid>
    </>
  )
}
